module.exports = __webpack_public_path__ + "media/images/lb/981-80e9ef2ecf2aaba8773bcb249e419cdd.svg";